import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faClock 
} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { contattiAzienda } from '../utils/data';
import ContactForm from '../components/ContactForm';

const Contattaci: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-primary to-primary/80 text-white">
        <div className="container mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Contattaci</h1>
            <p className="text-xl text-white/80">
              Richiedi una consulenza gratuita e senza impegno. Il nostro team ti aiuterà a confrontare le offerte disponibili per luce, gas e internet.
            </p>
            <p className="text-sm text-white/50 mt-4">
              Il nostro servizio è gratuito. Nessun obbligo di sottoscrizione.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="py-20">
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Contact Info */}
            <motion.div 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="lg:w-1/3"
            >
              <h2 className="text-3xl font-bold mb-8 text-primary">Informazioni di Contatto</h2>
              
              <div className="space-y-6">
                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  className="flex items-start"
                >
                  <div className="mr-4 mt-1">
                    <FontAwesomeIcon icon={faPhone} className="text-xl text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Consulenza Gratuita</h3>
                    <p className="text-light-muted mb-1">Chiamata senza impegno:</p>
                    <a href="tel:+390240055045" className="text-secondary hover:text-primary">{contattiAzienda.telefonoServizioClienti}</a>
                    <p className="text-light-muted mb-1 mt-2">Supporto Tecnico:</p>
                    <a href="tel:+390294753134" className="text-secondary hover:text-primary">{contattiAzienda.telefonoSupporto}</a>
                  </div>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="flex items-start"
                >
                  <div className="mr-4 mt-1">
                    <FontAwesomeIcon icon={faEnvelope} className="text-xl text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Email</h3>
                    <p className="text-light-muted mb-1 mt-2">Assistenza Clienti:</p>
                    <a href="mailto:info@serviziobolletta.it" className="text-secondary hover:text-primary">{contattiAzienda.email}</a>
                  </div>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="flex items-start"
                >
                  <div className="mr-4 mt-1">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-xl text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Sede Principale</h3>
                    <p className="text-light-muted">
                      {contattiAzienda.indirizzo}
                    </p>
                  </div>
                </motion.div>

                <motion.div 
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  className="flex items-start"
                >
                  <div className="mr-4 mt-1">
                    <FontAwesomeIcon icon={faClock} className="text-xl text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1">Orari di Apertura</h3>
                    <p className="text-light-muted mb-1">Lunedì - Venerdì:</p>
                    <p className="text-light-text">{contattiAzienda.orarioLavorativo}</p>
                    <p className="text-light-muted mb-1 mt-2">Sabato:</p>
                    <p className="text-light-text">{contattiAzienda.orarioSabato}</p>
                    <p className="text-light-muted mb-1 mt-2">Domenica:</p>
                    <p className="text-light-text">{contattiAzienda.orarioDomenica}</p>
                  </div>
                </motion.div>
              </div>
            </motion.div>

            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contattaci; 